module.exports = __webpack_public_path__ + "img/building.3dbfb985.jpg";